import React, { Component } from "react";
import PropTypes from "prop-types";
import deepEqual from "deep-equal";
import classnames from "classnames";
import CssTransitionGroup from "react-transition-group/CSSTransitionGroup";
import OkLoader from "shared/components/OkLoader";

import {
	SECTIONS,
} from "apps/discovery/util/consts";
import { getRowInfo } from "apps/discovery/util/helpers";

import Row from "apps/discovery/containers/Row";

import "./Section.scss";

class Section extends Component {
	constructor(props) {
		super(props);

		// the information about the row is static, but derived from the section
		// id, so calculate it once on mount and shove it in state.
		const rowInfo = getRowInfo(props.section.section_id);

		this.state = { ...rowInfo };
	}

	componentDidMount() {
		const { section, getSection } = this.props;
		const hasResults = section.results && section.results.rows &&
			section.results.rows.length;

		if (!hasResults) {
			getSection(section.section_id);
		}
	}

	shouldComponentUpdate(nextProps) {
		// check if the row is loading, since that's the easiest check
		if (nextProps.isLoading !== this.props.isLoading) {
			return true;
		}

		// get the rows
		let propRows = null;
		let nextPropRows = null;
		let shouldUpdate;

		if (this.props.section && this.props.section.results && this.props.section.results.rows) {
			propRows = this.props.section.results.rows;
		}

		if (nextProps.section && nextProps.section.results && nextProps.section.results.rows) {
			nextPropRows = nextProps.section.results.rows;
		}

		// do the checks
		if (!propRows && !nextPropRows) {
			shouldUpdate = false;
		} else if ((propRows && !nextPropRows) || (!propRows && nextPropRows)) {
			shouldUpdate = true;
		} else {
			shouldUpdate = !deepEqual(propRows, nextPropRows);
		}

		return shouldUpdate;
	}

	render() {
		const { section, isLoading } = this.props;
		const { Header, Template, templateName, sizing, blankRowProps } = this.state;
		const sectionClasses = {
			"discovery-section": true,
			[`discovery-section--${section.section_id}`]: true,
			[`layout--${templateName}`]: true,
		};

		const hasResults = !!(
			section.results &&
			section.results.rows &&
			section.results.rows.length
		);

		return (
			<div className={classnames(sectionClasses)}>
				<div className="discovery-section-content">
					<Header
						title={section.title}
						data={section.header_component.metadata}
					/>
					<div className="discovery-section-content-rows">
						{hasResults &&
							<span>
								<CssTransitionGroup
									transitionName="discovery-row-transition"
									transitionEnterTimeout={500}
									transitionLeaveTimeout={500}
								>
									{section.results.rows.map((row, i) =>
										(<Row
											key={row.id || i}
											sectionId={section.section_id}
											row={row}
											blankRowProps={blankRowProps}
											template={Template}
											sizing={sizing}
											isLoading={isLoading && i === 0}
										/>)
									)}
								</CssTransitionGroup>
								{isLoading &&
									<OkLoader
										show
										color={section.section_id === SECTIONS.interests ? "#d5e0f8" : "#4c7bd9"}
									/>
								}
							</span>
						}
						{!hasResults &&
							<Row
								sectionId={section.section_id}
								row={{
									title: section.section_id === SECTIONS.interests ? "They also like…" : null,
								}}
								blankRowProps={blankRowProps}
								template={Template}
								sizing={sizing}
								placeholder
								error={section.error}
							/>
						}
					</div>
				</div>
			</div>
		);
	}
}

Section.propTypes = {
	getSection: PropTypes.func.isRequired,
	section: PropTypes.object.isRequired,
	isLoading: PropTypes.bool.isRequired,
};

export default Section;



// WEBPACK FOOTER //
// ./src/apps/discovery/components/Section.jsx